<script setup>
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const handleReferralBackgroundDelete = () => {
    portalContentAndDesignStore.srcRoutes.referral_portal_background_image_path = null;
};
</script>

<template>
    <div class="divide-y">
        <div class="space-y-4">

            <radio-group-inline-color
                label="Background color"
                name="referral_portal_background_color"
                :model-value="portalContentAndDesignStore.portalLayoutSettings?.referral_portal_background_color || 'gray-50'"
                @picked="portalContentAndDesignStore.portalLayoutSettings.referral_portal_background_color = $event.finalValue"
                :options="[
                    { value: 'white', label: 'bg-white', label_is_class: true},
                    { value: 'gray-50', label: 'bg-gray-50', label_is_class: true},
                    { value: 'gray-100', label: 'bg-gray-100', label_is_class: true},
                    { value: 'gray-200', label: 'bg-gray-200', label_is_class: true},
                    { value: 'gray-300', label: 'bg-gray-300', label_is_class: true},
                    { value: 'custom', label: 'Custom', custom: { name: 'referral_portal_background_color', placeholder: '', type: 'input' }},
                ]"
            />

            <file-upload
                :src="portalContentAndDesignStore.srcRoutes?.referral_portal_background_image || ''"
                :path="portalContentAndDesignStore.srcRoutes?.referral_portal_background_image_path"
                no_src="/images/upload-image.png"
                accept="image/*"
                title="Background"
                name="referral_portal_background_image"
                :upload_url="portalContentAndDesignStore.getFileUploadRoute"
                :delete_url="portalContentAndDesignStore.getFileDeleteRoute"
                @delete:done="handleReferralBackgroundDelete"
            />

            <radio-group-inline-color
                label="Text color"
                name="referral_portal_text_color"
                :model-value="portalContentAndDesignStore.portalLayoutSettings?.referral_portal_text_color || 'gray-800'"
                @picked="portalContentAndDesignStore.portalLayoutSettings.referral_portal_text_color = $event.finalValue"
                :options="[
                    { value: 'gray-900', label: 'bg-gray-900', label_is_class: true},
                    { value: 'gray-800', label: 'bg-gray-800', label_is_class: true},
                    { value: 'gray-700', label: 'bg-gray-700', label_is_class: true},
                    { value: 'gray-600', label: 'bg-gray-600', label_is_class: true},
                    { value: 'gray-500', label: 'bg-gray-500', label_is_class: true},
                    { value: 'custom', label: 'Custom', custom: { name: 'referral_portal_text_color', placeholder: '', type: 'input' }},
                ]"
            />

            <radio-group-inline-color
                v-if="!portalContentAndDesignStore.portalLayoutSettings?.portal_layout_brand_primary_color_as_partner_and_pages_primary"
                label="Link color"
                name="referral_portal_link_color"
                :model-value="portalContentAndDesignStore.portalLayoutSettings?.referral_portal_link_color || 'teal-600'"
                @picked="portalContentAndDesignStore.portalLayoutSettings.referral_portal_link_color = $event.finalValue"
                :options="[
                    { value: 'indigo-700', label: 'bg-indigo-700', label_is_class: true},
                    { value: 'blue-700', label: 'bg-blue-700', label_is_class: true},
                    { value: 'cyan-700', label: 'bg-cyan-700', label_is_class: true},
                    { value: 'teal-600', label: 'bg-teal-600', label_is_class: true},
                    { value: 'black', label: 'bg-black', label_is_class: true},
                    { value: 'custom', label: 'Custom', custom: { name: 'referral_portal_link_color', placeholder: '', type: 'input' }},
                ]"
            />

        </div>
    </div>
</template>
